<template>
<form novalidate @submit.stop.prevent="addLayer" class="ql-new-layer-form">
    <h2 class="md-title">Add a New Layer</h2>
    <md-input-container>
        <label>Layer Title</label>
        <md-input required v-model="newLayerTitle"></md-input>
    </md-input-container>
    <color-picker v-model="colors" @input="pickColor" class="ql-color-picker"/>
    </br>
    <md-button class="md-raised md-primary" @click="addLayer">Add Layer</md-button>
</form>
</template>

<script>
import { Slider } from 'vue-color';

const LayersLayerNew = {
    name: 'LayersLayerNew',
    props: ['project'],
    data: function() {
        return {
            newLayerTitle: '',
            colorDetails: {},
            color: '',
            colors: {}
        };
    },
    methods: {
        addLayer() {
            const newLayer = {title: this.newLayerTitle, colorDetails: this.colorDetails, color: this.color};
            this.$emit('addLayer', newLayer);

            this.newLayerTitle = '';
            this.color = '';
            this.colorDetails = {};
            this.colors = {};
        },
        pickColor(e) {
            this.colorDetails = e;
            this.color = this.colorDetails.hex;
        }
    },
    components: {
        'color-picker': Slider
    }
};
export default LayersLayerNew;

</script>

<style lang="scss">
.ql-new-layer-form {
    padding: 1em;
    .ql-color-picker {
        width: 100%;
        display: block;
        clear: both;
    }
}
</style>


// WEBPACK FOOTER //
// layer-new.vue?f528d7cc